module.exports = __webpack_public_path__ + "img/MAX.e9242ee.svg";